import {api, BASE_URL} from "../config";
import { authFetch } from "../utils/authFetch";

const CRITERIA_URL = BASE_URL + "criteria/";

export function get_criteria_for_analysis(analysis_id, target_document_id) {
    return api
        .get(`${CRITERIA_URL}analysis/${analysis_id}/document/${target_document_id}`)
        .then((res) => res.data);
}

export function get_all_criteria() {
    return api.get(CRITERIA_URL).then((res) => res.data);
}

export function create_criterion(data) {
    return api.post(CRITERIA_URL, data).then((res) => res.data);
}

export function update_criterion(id, data) {
    return api.put(CRITERIA_URL + id, data).then((res) => res.data);
}

export function delete_criterion(id) {
    return api.delete(CRITERIA_URL + id).then((res) => res.data);
}

export function generate_prompt_from_title(title, description) {
    const lang = localStorage.getItem('lang') || 'en';

    return authFetch(
        `${CRITERIA_URL}stream-prompt?criterion=${encodeURIComponent(title)}&description=${encodeURIComponent(description || "")}`,
        {
            headers: {
                'X-Client-Language': lang,
            }
        }
    );
}



//
// export function generate_prompt_from_title(title,description) {
//     return fetch(CRITERIA_URL +`stream-prompt?criterion=${encodeURIComponent(title)}`);
// }
